// extracted by mini-css-extract-plugin
export default {"body":"FilterWrapper_body__jOaPc","title":"FilterWrapper_title__gtOgV","header":"FilterWrapper_header__2OM1I","border":"FilterWrapper_border__gI8dh"};